import classes from 'classnames';
import styles from './DesktopProductProperty.module.scss';

export type Props = {
  main?: boolean;
  loading?: boolean;
  label: React.ReactNode;
  value: React.ReactNode;
  valueSuffix?: React.ReactNode;
};

export default function DesktopProductProperty({
  main = false,
  loading = false,
  label,
  value,
  valueSuffix,
}: Props) {
  const blurClassNames = classes(
    styles['value-loading'],
    loading ? '' : styles['value-loading--done'],
  );

  return (
    <div
      className={classes(styles.wrapper, main ? styles.main : null)}
      data-test="css-Amount-Elements"
    >
      <span className={styles.label} data-test="css-Amount-Title">
        {label}
      </span>

      <div className={classes(styles['value-wrapper'], blurClassNames)}>
        <span className={styles.value} data-test="css-Amount-Value">
          {value}
        </span>
        {valueSuffix && (
          <span className={styles['value-suffix']} data-test="css-Amount-Type">
            {valueSuffix}
          </span>
        )}
      </div>
    </div>
  );
}
